import React, { useState } from "react";
import "./TrackerModal.css";
import * as FeatherIcon from "react-feather";

const TrackerModal = ({ trackerData = [], onTrack, onClose }) => {
  const [expanded, setExpanded] = useState({});
  const [selected, setSelected] = useState({});

  const toggleCategory = (cat) => {
    setExpanded((prev) => ({ ...prev, [cat]: !prev[cat] }));
  };

  const handleCategoryCheck = (cat, isChecked) => {
    const subs = trackerData.find((c) => c.name === cat)?.subDimensions || [];
    setSelected((prev) => ({
      ...prev,
      [cat]: isChecked ? new Set(subs) : new Set(),
    }));
  };

  const handleSubCheck = (cat, sub, isChecked) => {
    setSelected((prev) => {
      const updated = new Set(prev[cat] || []);
      isChecked ? updated.add(sub) : updated.delete(sub);
      return { ...prev, [cat]: updated };
    });
  };

  const isCategoryChecked = (cat) => {
    const subs = trackerData.find((c) => c.name === cat)?.subDimensions || [];
    return selected[cat]?.size === subs.length;
  };

  const isSubChecked = (cat, sub) => selected[cat]?.has(sub);

  const handleTrack = () => {
    const result = {};
    for (let cat in selected) {
      if (selected[cat].size > 0) {
        result[cat] = Array.from(selected[cat]);
      }
    }
    onTrack(result);
  };

  return (
    <div className="tracker-panel">
      <div className="tracker-panel-header">
        <span className="tracker-title">Tracker</span>
      </div>

      <h4 className="section-heading">Select metrics to track</h4>

      <div className="category-list">
        {trackerData.map(({ name, subDimensions }) => (
          <div key={name} className="category-block">
            <div className="category-header">
              <button
                className="toggle-btn"
                onClick={() => toggleCategory(name)}
              >
                {expanded[name] ? (
                  <FeatherIcon.ChevronUp className="accord_arrow" />
                ) : (
                  <FeatherIcon.ChevronDown className="accord_arrow" />
                )}
              </button>
              <input
                type="checkbox"
                checked={isCategoryChecked(name)}
                onChange={(e) => handleCategoryCheck(name, e.target.checked)}
              />
              <span className="category_dropdown_head">{name}</span>
            </div>
            {expanded[name] && (
              <div className="subcategory-list">
                {subDimensions.map((sub) => (
                  <div
                    key={sub}
                    className={`subcategory-item ${
                      isSubChecked(name, sub) ? "checked" : ""
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={isSubChecked(name, sub)}
                      onChange={(e) =>
                        handleSubCheck(name, sub, e.target.checked)
                      }
                    />
                    <span className="category_dropdown_subhead">{sub}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="export_block_footer" style={{textAlign:'right'}}>
        <button className="track-btn" onClick={handleTrack}>
          Add to Tracker
        </button>
      </div>
    </div>
  );
};

export default TrackerModal;
